import { render } from "./ProductInfo.vue?vue&type=template&id=9eebfdb4&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=9eebfdb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eebfdb4"]])

export default __exports__